// @ts-nocheck
export interface AudioRecorder {
  start: {
    (): void;
  };
  pause: {
    (): void;
  };
  stop: {
    (): void;
  };
}

export interface DataCallback {
  (data: Blob): void;
}

export async function getAudioRecorder(
  callback: DataCallback
): Promise<AudioRecorder> {
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  const recorder = new MediaRecorder(stream);
  const start = () => recorder.start();
  const pause = () => recorder.pause();
  const stop = () => recorder.stop();
  recorder.ondataavailable = (e: any) => {
    callback(e.data);
  };
  return { start, pause, stop };
}
